export default {
  username: ['用户名称', 'Username'],
  usernamePlaceholder: ['请输入用户名称', 'Please Enter Username'],
  usernameRequire: ['当前用户名称不能为空', 'Current user name cannot be empty'],
  usernameCorrectly: ['请输入正确的用户名称', 'Please enter the correct username'],
  usernameDuplicated: ['当前用户名称已存在', 'Current user name already exists'],
  role: ['权限组', 'Role Group'],
  rolePlaceholder: ['请选择权限组', 'Please Enter Role Group'],
  password: ['用户密码', 'Password'],
  passwordTips: [
    '密码最小为12位，由大写字母、小写字母、符号、数字组合',
    'The password must be at least 12 digits and be composed of uppercase letters, lowercase letters, symbols, and numbers'
  ],
  passwordPlaceholder: ['请输入用户密码', 'Please Enter Password'],
  passwordRequire: ['请输入用户密码', 'Please Enter Password!'],
  passwordMinLength: ['密码长度必须大于12位', 'Password length must be greater than 12 digits'],
  passwordMaxLength: ['密码长度已超出20位', 'Password length has exceeded 20 digits'],
  passwordLowercase: ['密码必须包含小写字母a-z', 'Password must contain lowercase letters a-z'],
  passwordUppercase: ['密码必须包含大写字母A-Z', 'Password must contain uppercase letters A-Z'],
  passwordNumber: ['密码必须包含数字0-9', 'Password must contain numbers 0-9'],
  passwordSymbol: ['密码必须包含符号@$!%*?&-+', 'Password must contain the symbol @$!%*?&-+'],
  passwordCheck: ['再次验证', 'Password Check'],
  passwordCorrectly: ['请输入正确的用户密码', 'Please enter the correct user password'],
  resource: ['资源策略', 'Resource Policy'],
  checked: ['选中', 'Checked'],
  unchecked: ['取消', 'UnChecked'],
  expand: ['展开', 'Expand'],
  close: ['收起', 'Close'],
  permission: ['特殊授权', 'Permission'],
  permissionPlaceholder: ['请选择特殊授权代码', 'Please select permission key'],
  call: ['称呼', 'Call Name'],
  callPlaceholder: ['请输入称呼', 'Please Enter Call Name'],
  email: ['电子邮件', 'Email'],
  emailPlaceholder: ['请输入电子邮件', 'Please Enter Email'],
  emailCorrectly: ['请输入正确的电子邮件', 'Please enter the correct email'],
  phone: ['联系电话', 'Phone'],
  phonePlaceholder: ['请输入手机号码', 'Please Enter Phone'],
  avatar: ['头像', 'Avatar'],
  selfTip: ['检测到为当前登录用户', 'Detected as currently logged in user'],
  goProfile: ['前往个人中心', 'Go Profile']
};
